import { FC, memo } from 'react';

import * as Meta from '@Queries/Meta';
import usePage from '@Queries/usePage';
import TemplateService from '@Templates/TemplateService';
import PageShowRoom, { PageShowroomData } from '@Pages/PageShowroom';

const RouteCategory: FC = () => {
  const page = usePage<PageShowroomData>();
  const meta = Meta.useMeta();

  if (!page.isSuccess || !meta.isSuccess) return null;

  return (
    <TemplateService title={page.data.meta.h1} breadcrumbs={page.data.breadcrumbs}>
      <PageShowRoom page={page.data} />
    </TemplateService>
  );
};

export default memo(RouteCategory);
